import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { signOutUserStart } from './../redux/User/user.actions';
import logo from './../../src/assets/CD Horizontal_whiteFont_opt.png';
import * as ROUTES from './../components/Routes';


const mapState = ({ user }) => ({
	currentUser: user.currentUser
})

const DashBoardLayout = props => {
  const dispatch = useDispatch();
  const [active, setActive] = useState(false);
  const { currentUser } = useSelector(mapState);

  const signOut = () => {
    dispatch(signOutUserStart());
  };

  const handleClick = () => {
    setActive(!active);
  };

  return (
    <div className="dashContainter verticalNav">


      {/* -- mobile menu bar -- */}
      <div className="dash">
        <nav className="container text-white">
          <div className="topMenu">
            <Link to={ROUTES.DASHBOARD}>
              <img className="head-logo" src={logo} alt="chore door logo"/>
            </Link>
            <div className="p-1">
              <button className="mobile-menu" onClick={handleClick}>
                <svg
                  className='svgIcon'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M4 6h16M4 12h16M4 18h16'
                  />
                </svg>
              </button>
            </div>
          </div>
        </nav>


        {/* sidebar */}
        <div className={`${active ? '' : 'mobSide'} text-white sideDash space-y-6 py-4 absolute inset-y-0 left-0  transform transition duration-200 ease-in-out z-10 menu`}>
          <div className="img pb-2">
              
              <span className="displayName">
                {currentUser.displayName}
              </span>
          </div>
          <nav className="">
              {!currentUser.subscribed &&(
                <ul>
                  <li>
                    <Link to={ROUTES.DASHBOARD}>
                      DASHBOARD
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTES.ACCT_DETAILS}>
                      ACCOUNT DETAILS
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTES.SUBSCRIBE}>
                      SUBSCRIBE
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTES.CONTACT}>
                      CONTACT US
                    </Link>
                  </li>
                  <li>
                    <span className="signOut" onClick={() => signOut()}>
                      LOG OUT
                    </span>
                  </li>
                </ul>
              )}

              {currentUser.subscribed &&(
                <ul>
                  <li>
                    <Link to={ROUTES.DASHBOARD}>
                      DASHBOARD
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTES.CALENDAR}>
                      CALENDAR
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTES.NEEDED_SERVICE}>
                      WHAT DO YOU NEED?
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTES.CONVERSATIONS}>
                    CONVERSATIONS
                    </Link>
                  </li>
                  <li>
                    <Link to ={ROUTES.RECEIPTS}>
                        FILING CABINET
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTES.ACCT_DETAILS}>
                      ACCOUNT DETAILS
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTES.SERVICES}>
                      ADD-ON SERVICES
                    </Link>
                  </li>
                  <li>
                    <Link to={ROUTES.SUBSCRIBE}>
                      SUBSCRIPTION
                    </Link>
                  </li>
                  
                  <li>
                    <span className="signOut" onClick={() => signOut()}>
                      LOG OUT
                    </span>
                  </li>
                  
                </ul>
              )}
          </nav>    
        </div>
      </div>

              {/*DESKTOP sidebar */}
      <div className={`text-white mainSideDash  menu`}>


        <div className="vertimgLogo pt-5 pb-3">
            <img className="head-logo px-2" src={logo} alt="chore door logo"/>
            <span className="displayName">
              {currentUser.displayName}
            </span>
        </div>
        <nav className="">
            {!currentUser.subscribed &&(
              <ul>
                <li>
                  <Link to={ROUTES.DASHBOARD}>
                    DASHBOARD
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.ACCT_DETAILS}>
                    ACCOUNT DETAILS
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.SUBSCRIBE}>
                    SUBSCRIBE
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.CONTACT}>
                    CONTACT US
                  </Link>
                </li>
                <li>
                  <span className="signOut" onClick={() => signOut()}>
                    LOG OUT
                  </span>
                </li>
              </ul>
            )}

            {currentUser.subscribed &&(
              <ul>
                <li>
                  <Link to={ROUTES.DASHBOARD}>
                    DASHBOARD
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.CALENDAR}>
                    CALENDAR
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.NEEDED_SERVICE}>
                    WHAT DO YOU NEED?
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.CONVERSATIONS}>
                    CONVERSATIONS
                  </Link>
                </li>
                <li>
                  <Link to ={ROUTES.RECEIPTS}>
                      FILING CABINET
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.ACCT_DETAILS}>
                    ACCOUNT DETAILS
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.SERVICES}>
                    ADD-ON SERVICES
                  </Link>
                </li>
                <li>
                  <Link to={ROUTES.SUBSCRIBE}>
                    SUBSCRIPTION
                  </Link>
                </li>
                
                <li>
                  <span className="signOut" onClick={() => signOut()}>
                    LOG OUT
                  </span>
                </li>
                
              </ul>
            )}
        </nav>    
    </div>






    
      {/* -- Content -- */}
      <div className="content">
          {props.children}
      </div>
    </div>
  );
};

export default DashBoardLayout;




